module.exports = __webpack_public_path__ + "img/ic_item_gk_click.5c44a738.png";